import { render, staticRenderFns } from "./SPIFCustomizeReport.vue?vue&type=template&id=2c9ac4c7&scoped=true"
import script from "./SPIFCustomizeReport.vue?vue&type=script&lang=js"
export * from "./SPIFCustomizeReport.vue?vue&type=script&lang=js"
import style0 from "./SPIFCustomizeReport.vue?vue&type=style&index=0&id=2c9ac4c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9ac4c7",
  null
  
)

export default component.exports